import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/chevron-down.svg';
import MdmLink from '~/components/atoms/MdmLink.vue';
import MdmIcon from '~/components/atoms/Global/MdmIcon';
export default {
  name: 'NavigationBar',
  components: {
    MdmLink: MdmLink,
    MdmIcon: MdmIcon
  },
  props: {
    navigation: {
      type: Array,
      required: true
    },
    services: {
      type: Array,
      required: true
    },
    openedMenu: {
      type: String,
      required: true
    }
  },
  methods: {
    handleClick: function handleClick(item, event) {
      if (item.type === 'link') {
        this.$root.$emit('generic-tracking', event, {
          data: item.tracking
        });
      } else {
        event.preventDefault();
        this.$emit('select-item', item);
      }
    }
  }
};